import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

async function call(name, payload = {}) {
  const response = await httpsCallable(functions, name)(payload);
  return response.data;
}

export const listIncidentManagers = () => call("listIncidentManagers");
export const createIncidentDraft = () => call("createIncidentDraft");
export const saveIncidentSection = (payload) => call("saveIncidentSection", payload);
export const submitIncident = (payload) => call("submitIncident", payload);
export const handoffInjuryIncident = (payload) => call("handoffInjuryIncident", payload);
export const startIncidentReview = (incidentId) => call("startIncidentReview", { incidentId });
export const saveManagerSection = (payload) => call("saveManagerSection", payload);
export const upsertCorrectiveAction = (payload) => call("upsertCorrectiveAction", payload);
export const completeCorrectiveAction = (payload) => call("completeCorrectiveAction", payload);
export const closeIncident = (payload) => call("closeIncident", payload);
export const registerIncidentAttachment = (payload) => call("registerIncidentAttachment", payload);
export const removeIncidentAttachment = (payload) => call("removeIncidentAttachment", payload);
